import * as v from 'valibot';

export interface Skill {
  name: string;
  description?: string;
  guid: string;
  job_titles?: string[];
  job_title_count?: number;
  learner_count?: number;
  courses?: Course[];
  course_count?: number;
  last_modified?: string;
  status?: Status;
}

export interface Course {
  id: number;
  name: string;
  portal_id: number;
  contains_assignments: boolean;
  contains_checklists: boolean;
  published_status_id: CoursePublishedStatus;
  number_scoreables: number;
  url?: string;
  guid?: string;
  manager_can_enroll: boolean;
}

export enum CoursePublishedStatus {
  PUBLISHED = 1,
  DELETED = 2,
  DRAFT = 3,
  ARCHIVED = 4,
  UNDER_REVISION = 5,
}

export enum Status {
  ACTIVE,
  INACTIVE,
  ARCHIVED,
}

export const SkillAssociatedWithCourseSchema = v.object({
  guid: v.string(),
  name: v.string(),
});

export type SkillAssociatedWithCourse = v.InferOutput<typeof SkillAssociatedWithCourseSchema>;
